import config from "@/environment";
import { H1 } from "@components/utilities";
import { useFeatureFlags } from "@hooks/http";

import { AmazonConnectionCard } from "./amazon";
import { AmazonSellerConnectionCard } from "./amazon-seller";
import { ApplovinConnectionCard } from "./applovin";
import { AttentiveMobileConnectionCard } from "./attentive-mobile";
import { FBConnectionCard } from "./facebook";
import { AdwordsConnectionCard } from "./google-ads";
import { KlaviyoConnectionCard } from "./klaviyo";
import { MicrosoftConnectionCard } from "./microsoft";
import { MNTNConnectionCard } from "./mntn";
import { PinterestConnectionCard } from "./pinterest";
import { RakutenConnectionCard } from "./rakuten";
import { ShopifyConnectionCard } from "./shopify";
import { SnapchatConnectionCard } from "./snapchat";
import { TatariConnectionCard } from "./tatari";
import { TikTokConnectionCard } from "./tiktok";
import { TradeDeskConnectionCard } from "./trade-desk";
import { TwitterConnectionCard } from "./twitter";
import { VibeConnectionCard } from "./vibe";

interface ConnectionsProps {
  integrationDetails: any;
}

export const Connections = ({ integrationDetails }: ConnectionsProps) => {
  const { hasFeatureFlag } = useFeatureFlags();
  return (
    <>
      <H1>Connections</H1>
      <p>
        Please connect your platform accounts to Northbeam. If prompted, please
        give Northbeam the maximum number of requested permissions for each
        platform. These connections are critical for providing a holistic view
        of your advertising performance.
      </p>
      <hr />
      <>
        {config.isNBInternal ? (
          <p>
            (Note: some of these connections don&apos;t work on canary or
            staging.)
          </p>
        ) : (
          <></>
        )}
      </>
      <FBConnectionCard integrationDetails={integrationDetails} />
      <AdwordsConnectionCard integrationDetails={integrationDetails} />
      <ShopifyConnectionCard integrationDetails={integrationDetails} />
      <MicrosoftConnectionCard integrationDetails={integrationDetails} />
      <SnapchatConnectionCard integrationDetails={integrationDetails} />
      {/* <LinkedInConnectionCard integrationDetails={integrationDetails} /> */}
      <PinterestConnectionCard integrationDetails={integrationDetails} />
      <TikTokConnectionCard integrationDetails={integrationDetails} />
      <AmazonConnectionCard integrationDetails={integrationDetails} />
      <AmazonSellerConnectionCard integrationDetails={integrationDetails} />
      <TwitterConnectionCard integrationDetails={integrationDetails} />
      <KlaviyoConnectionCard />
      {hasFeatureFlag("enableApplovinConnection") && <ApplovinConnectionCard />}
      {hasFeatureFlag("enableTatariConnection") && <TatariConnectionCard />}
      {hasFeatureFlag("enableAttentiveConnection") && (
        <AttentiveMobileConnectionCard />
      )}
      {hasFeatureFlag("enableMNTNConnection") && <MNTNConnectionCard />}
      {hasFeatureFlag("enableTradeDeskConnection") && (
        <TradeDeskConnectionCard />
      )}
      {hasFeatureFlag("enableRakutenConnection") && <RakutenConnectionCard />}
      {hasFeatureFlag("enableVibeConnection") && <VibeConnectionCard />}
    </>
  );
};
